import { render, staticRenderFns } from "./dialog-settle-setting.vue?vue&type=template&id=6fd87aff&"
import script from "./dialog-settle-setting.vue?vue&type=script&lang=js&"
export * from "./dialog-settle-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports